import { Link, useParams } from "react-router-dom";
import { getPostBySlug } from "../lib/blog";
import { BlogMarkdown } from "../components/blog/BlogMarkdown";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { NotFoundPage } from "./NotFoundPage";

export function BlogPostPage() {
  const { slug } = useParams();
  const post = slug ? getPostBySlug(slug) : undefined;

  useDocumentTitle(post ? `${post.meta.title} — Pilot Mastery Academy` : "Article — Pilot Mastery Academy");

  if (!post) {
    return <NotFoundPage />;
  }

  return (
    <div className="mx-auto max-w-3xl px-4 py-12">
      <nav className="text-sm text-slate-500">
        <Link to="/blog" className="hover:text-signal-sky">
          Journal
        </Link>
        <span className="mx-2">/</span>
        <span className="text-slate-400">{post.meta.title}</span>
      </nav>
      <header className="mt-8 border-b border-white/10 pb-8">
        <time className="text-sm text-slate-500">{post.meta.date}</time>
        <h1 className="mt-2 font-display text-4xl font-semibold text-white">{post.meta.title}</h1>
        <p className="mt-4 text-lg text-slate-400">{post.meta.description}</p>
      </header>
      {post.meta.featuredImage && (
        <img
          src={post.meta.featuredImage}
          alt={post.meta.imageAlt || post.meta.title}
          className="mt-8 w-full rounded-xl object-cover shadow-lift"
          style={{ maxHeight: "420px" }}
        />
      )}
      <div className="mt-10">
        <BlogMarkdown content={post.body} />
      </div>
    </div>
  );
}
